(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jco-mystery-parcel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jco-peel-parcel')) {
    customElements.define('jco-peel-parcel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.ready) return;

        this.button = this.querySelector('.jpp-open');
        if (!this.button) return;

        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('.jpp-result'));
        this.reveal = this.querySelector('.jpp-reveal');
        this.status = this.querySelector('.jpp-status');
        this.stage = this.querySelector('.jpp-stage');
        this.last = -1;
        this.timers = [];
        this.particles = [];

        this.button.disabled = false;
        this.button.addEventListener('click', () => this.open());

        this.querySelector('.jpp-again').addEventListener(
          'click',
          () => this.reset()
        );
      }

      later(fn, delay) {
        this.timers.push(setTimeout(fn, delay));
      }

      clear() {
        (this.timers || []).forEach(clearTimeout);
        this.timers = [];

        (this.particles || []).forEach(image => image.remove());
        this.particles = [];
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.clear();

        if (this.ready) this.reset(false);
      }

      reset(focus = true) {
        this.clear();
        this.removeAttribute('data-phase');

        this.reveal.hidden = true;
        this.button.hidden = false;
        this.button.disabled = false;

        this.cards.forEach(card => {
          card.hidden = true;
        });

        this.status.textContent = focus
          ? 'Another surprise is ready to open.'
          : '';

        if (focus) {
          this.button.focus({ preventScroll: true });
        }
      }

      open() {
        if (this.button.disabled || !this.cards.length) return;

        this.button.disabled = true;

        const choices = this.cards.filter(
          (card, index) => this.cards.length === 1 || index !== this.last
        );

        const card = choices[Math.floor(Math.random() * choices.length)];

        this.last = this.cards.indexOf(card);

        this.cards.forEach(item => {
          item.hidden = item !== card;
        });

        const image = card.querySelector('img');
        if (image) image.loading = 'eager';

        this.status.textContent = 'Opening your little surprise...';

        const reduced = matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        const show = () => {
          this.dataset.phase = 'revealed';
          this.reveal.hidden = false;

          if (!reduced) {
            this.reveal.animate(
              [
                {
                  opacity: 0,
                  transform: 'translateY(85px) scale(.8)'
                },
                {
                  opacity: 1,
                  transform: 'translateY(0) scale(1)'
                }
              ],
              {
                duration: 850,
                easing: 'cubic-bezier(.2,.8,.2,1)'
              }
            );

            this.burst();
          }

          this.status.textContent =
            'Inside your parcel: ' + card.dataset.title;

          card.querySelector('.jpp-shop').focus({
            preventScroll: true
          });
        };

        if (reduced) {
          show();
          this.button.hidden = true;
          return;
        }

        this.dataset.phase = 'peeling';

        this.later(() => {
          this.dataset.phase = 'opening';
        }, 750);

        this.later(show, 1250);

        this.later(() => {
          this.button.hidden = true;
        }, 2150);
      }

      burst() {
        const files = [
          'Rounded_Sky-Blue_Star.png',
          'yellow-star.png',
          'Glossy_Coral_Heart_Sticker.png',
          'Bold_Cartoon_Daisy_Icon_e57c1106-d673-4091-bbcc-204f509a40a0.png'
        ];

        for (let i = 0; i < 8; i++) {
          const image = document.createElement('img');

          image.src =
            'https://jcocollective.com/cdn/shop/files/' +
            files[i % files.length] +
            '?width=80';

          image.className = 'jpp-particle';
          image.alt = '';
          image.setAttribute('aria-hidden', 'true');

          this.stage.appendChild(image);
          this.particles.push(image);

          const x = (i - 3.5) * 38;
          const y = -90 - Math.random() * 90;

          const motion = image.animate(
            [
              {
                opacity: 0,
                transform: 'translate(-50%,-50%) scale(.3)'
              },
              {
                opacity: 1,
                transform: `translate(${x}px,${y}px) rotate(${x}deg)`,
                offset: .4
              },
              {
                opacity: 0,
                transform:
                  `translate(${x * 1.2}px,35px) ` +
                  `rotate(${x * 1.8}deg) scale(.5)`
              }
            ],
            {
              duration: 1600,
              easing: 'ease-out'
            }
          );

          motion.finished.then(
            () => image.remove(),
            () => image.remove()
          );
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
